import { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast-custom.css';
import { Box } from '@mui/material';

export const Toast: FC = () => {
  return (
    <Box
      sx={{
        '& .Toastify__toast-container': {
          width: 1,
          maxWidth: 400,
        },
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        rtl={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        stacked
        theme="colored"
      />
    </Box>
  );
};
